import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
// /nom-bonic-programa/videos/

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS, 'programa', 'videos']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;

    let path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'videos'];
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    if (mapping?.lay?.includes('videos-capitolats')) {
        path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'videos-capitolats-programa'];
    }

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
